import React from 'react'
import { COLORES } from '../../../../config/colores'
import { cerealesColor } from '../../../../config/cereales'
import BlockIcon from '@material-ui/icons/Block'
import ErrorIcon from '@material-ui/icons/Error'
import { Tooltip } from '@material-ui/core'
import DetalleProductosCondicionales from '../reporteCamionesCalados/DetalleProductosCondicionales'

function CantidadProductosPorCereal (props) {
  const {
    productosPorCereal,
    titulo,
    totalProductos = null,
    tituloTotal = null,
    detalleProductos = null,
    cortes = false,
    subtitulo = null
  } = props

  return (
    <>
      <div style={{ color: COLORES.grey.dark }}>
        <h4 style={{ marginBottom: '8px', fontWeight: 'bold' }}>{titulo}</h4>
        {subtitulo && <h6 style={{ marginBottom: '8px', fontWeight: 'bold' }}>{subtitulo}</h6> }
        <DetalleProductosCondicionales
          detalleProductos={detalleProductos}
          totalProductos={totalProductos}
          tituloTotal={tituloTotal}
        />
        <div style={{ marginTop: '22px' }}>
          { productosPorCereal.map((p, i) => {
            return (
              <div key={`${p.cantidad}- ${p.cereal} - ${i}`}>
                <h6
                  key={i}
                  style={{
                    color: COLORES.grey.dark,
                    margin: '5px',
                    padding: '5px',
                    fontWeight: 'bold',
                    backgroundColor: '#f4f4f4',
                    borderRadius: '22px',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      backgroundColor: cerealesColor[p.cereal.trim()],
                      height: '22px',
                      width: '22px',
                      borderRadius: '150px'
                    }}
                  />
                  <div style={{ textAlign: 'center', width: '80%' }}>
                    {p.calle ? `${p.calle} - ` : null} {p.cereal} : {p.cantidad}
                    {props.detalleCalificacion &&
                      <small style={{ margin: 0, padding: 0 }}>
                        {p.calificacion.trim() !== '' ? ` - (${p.calificacion.trim()})` : null}
                        {p.fecha && <small> {p.fecha} </small>}
                      </small>
                    }
                  </div>

                  {p.caravana === false &&
                    <>
                      <Tooltip title={'Silo aparte'}>
                        <ErrorIcon style={{ color: COLORES.error }} />
                      </Tooltip>
                      <small>Silo aparte</small>
                    </>
                  }

                  {cortes && p.productoCortado
                    ? <Tooltip title={'Producto cortado'}>
                      <BlockIcon style={{ color: COLORES.error }} />
                    </Tooltip>
                    : <></>
                  }
                </h6>
                {/* <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignContent: 'flex-start',
                    flexWrap: 'wrap',
                    justifyContent: 'center'
                  }}
                >
                  {props.detalleCalificacion &&
                    <small style={{ margin: 0, padding: 0 }}>
                      {p.fecha && <small> {p.fecha}</small>}
                      {p.calificacion.trim() !== '' ? ` - (${p.calificacion})` : null}
                    </small>
                  }
                </div> */}
              </div>

            )
          })}
        </div>
      </div>
    </>
  )
}

export default CantidadProductosPorCereal
